import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { DeclarationOverviewStatus } from '../components/organisms/DeclarationsOverview/DeclarationsOverview';
import { SATLinkStatus } from '../@types/SATLinking';

const useAnnualLogic = () => {
	const { declarationsOverviewDetail } = useSelector(
		(state: RootState) => state.tax,
	);
	const { status } = useSelector((state: RootState) => state.satLinkStatus);
	const { annualDeclarationOverview } = useSelector(
		(state: RootState) => state.tax,
	);
	const userHasPendingDeclarations = declarationsOverviewDetail?.some(
		(declaration) => {
			const declarationYear = declaration.declaration_period?.split('-')?.[1];
			return (
				declaration.type !== 'annual' &&
				declarationYear === '2024' &&
				declaration.obligation_compliance_check ===
					DeclarationOverviewStatus.MISSING &&
				declaration?.period_hired_with_heru === 'Period no contratado'
			);
		},
	);

	const userIsLinked = Boolean(status?.status === SATLinkStatus.ACTIVE);
	const userHasPendingActions = userHasPendingDeclarations;
	const userCanViewDeclarationOverview = userIsLinked && false;

	const haveMultipleRegimes = annualDeclarationOverview
		? annualDeclarationOverview?.incomes?.detail_incomes?.length > 1
		: false;
	const haveMoreThan400000Incomes = annualDeclarationOverview
		? annualDeclarationOverview?.incomes?.total_incomes > 400000
		: false;

	const hasMultipleIssuersInRegime = (() => {
		if (!annualDeclarationOverview?.incomes?.detail_incomes) return false;

		return annualDeclarationOverview?.incomes?.detail_incomes?.some(
			(regime) => {
				if (!regime.invoices) return false;

				const uniqueIssuers = new Set(
					regime.invoices.map((invoice) => invoice.issuer),
				);
				return uniqueIssuers.size > 1;
			},
		);
	})();
	return {
		userHasPendingActions,
		userHasPendingDeclarations,
		userCanViewDeclarationOverview,
		haveMultipleRegimes,
		haveMoreThan400000Incomes,
		hasMultipleIssuersInRegime,
	};
};

export default useAnnualLogic;
